import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'on-required-field-display',
    templateUrl: './required-field-display.component.html',
    styleUrls: ['./required-field-display.component.scss'],
})
export class RequiredFieldDisplayComponent {
    @Input() field: AbstractControl;

    constructor() {}
}
